import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class LoginService {

    login(data) {
        return axiosInstance.post(`${config.api.version}/auth/signin`, data)
    }

    reset(token, data) {
        return axiosInstance.post(`${config.api.version}/auth/reset/${token}`, data)
    }

    verify(token) {
        return axiosInstance.get(`${config.api.version}/auth/signup/verify/${token}`)
    }

}
